import { Filter, FilterItem } from "styles/jss/ProductsPage.styles";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { useQuery } from "@tanstack/react-query";
import { CustomTextField } from "styles/jss/Inputs.styles";
import { Divider, MenuItem } from "@mui/material";
import Loader from "../../Loader";
import { getFilters } from "services/products.api";

const ProductFilter = ({
  applications,
  markets,
  methods,
  types,
  setType,
  type,
  setApplication,
  application,
  setMarket,
  market,
  setMethod,
  method,
}) => {
  const { t } = useTranslation(["products"]);
  const { locale, push } = useRouter();

  const handleChange = (evt, setFilter, filterType) => {
    setFilter(evt.target.value);
    if (filterType === "type" && evt.target.value !== "all") {
      const getTypeName = types.data.filter(
        item => item.id === evt.target.value,
      );
      const url = `?type=${getTypeName[0].attributes.name
        .toString()
        .toLowerCase()}`;
      push(url, url, { shallow: true, locale });
      return;
    }
    if (filterType === "type" && evt.target.value === "all") {
      const url = "products";
      push(url, url, { shallow: true, locale });
    }
  };

  return (
    <Filter>
      <FilterItem>
        <CustomTextField
          select
          fullWidth
          size="small"
          label={t("p-type")}
          value={type}
          onChange={evt => handleChange(evt, setType, "type")}
        >
          <MenuItem value={"all"}>All</MenuItem>
          {types?.data.map(item => (
            <MenuItem key={item.id} value={item.id}>
              {item.attributes.name.toString()}
            </MenuItem>
          ))}
        </CustomTextField>
      </FilterItem>
      <Divider orientation="vertical" flexItem />
      <FilterItem>
        <CustomTextField
          select
          fullWidth
          size="small"
          variant="outlined"
          label={t("p-application")}
          value={application}
          onChange={evt => handleChange(evt, setApplication, "application")}
        >
          <MenuItem value={"all"}>All</MenuItem>
          {applications?.data.map(item => (
            <MenuItem key={item.id} value={item.id}>
              {item.attributes.application.toString()}
            </MenuItem>
          ))}
        </CustomTextField>
      </FilterItem>
      <Divider orientation="vertical" flexItem />
      <FilterItem>
        <CustomTextField
          select
          fullWidth
          size="small"
          variant="outlined"
          label={t("p-market")}
          value={market}
          onChange={evt => handleChange(evt, setMarket, "market")}
        >
          <MenuItem value={"all"}>All</MenuItem>
          {markets?.data.map(item => (
            <MenuItem key={item.id} value={item.id}>
              {item.attributes.market.toString()}
            </MenuItem>
          ))}
        </CustomTextField>
      </FilterItem>
      <Divider orientation="vertical" flexItem />
      <FilterItem>
        <CustomTextField
          select
          fullWidth
          size="small"
          variant="outlined"
          label={t("p-method")}
          value={method}
          onChange={evt => handleChange(evt, setMethod, "method")}
        >
          <MenuItem value={"all"}>All</MenuItem>
          {methods?.data.map(item => (
            <MenuItem key={item.id} value={item.id}>
              {item.attributes.method.toString()}
            </MenuItem>
          ))}
        </CustomTextField>
      </FilterItem>
    </Filter>
  );
};

export default ProductFilter;
